import { API_GRAPHQL } from "../../../constants";
import {useState, useEffect} from 'react';
//import { getLocalStorageItem } from "../../../helpers/storage";

export function useRetrieveOrderedProductsGraphQL(id) {
    const url = `${API_GRAPHQL}`;
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    //const info = getLocalStorageItem('user');
    //const id = info.user.id;
  
    useEffect(() => {
        async function getProducts(url) {
            try {
                setIsLoading(true);
                setIsError(false);
  
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      query:`{
                        orderedProducts(
                          pagination: {limit: 100},
                          filters: {customer: {id:{eq:${id}}}}) {
                          data{
                            id
                            attributes{
                              product_delivered_date
                              first_time_delivery
                              serial_number
                              product{
                                data{
                                  id
                                  attributes{
                                    name
                                    varenummer
                                    image{
                                      data{
                                        attributes{
                                          url
                                        }
                                      }
                                    }
                                    supplier{
                                      data{
                                        attributes{
                                          name
                                        }
                                      }
                                    }
                                    category{
                                      data{
                                        id
                                        attributes{
                                          place
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }`
                    })
                });
  
                const result = await response.json();
                setProducts(result.data.orderedProducts.data);
            } catch(error) {
                console.error(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }
  
        getProducts(url);
    }, [url, id]);
  
    return {products, isLoading, isError};
  }
  
  export default useRetrieveOrderedProductsGraphQL;